import React, { use, useEffect, useState } from "react";
import PDFViewer from "./pdf-viewer";
import { useNavigate } from "react-router-dom";
import { getAIUsecaseDocumentAPI } from "../../service/ai.service";
import { useAppContext } from "../../context/app.context";
import Modal from "../../component/modal";
import { DisabledNavLink } from "../../component/sidemenu";
import { SECTION_NAMES } from "../../helper/constant";

const AIUsecase = () => {
    const navigate = useNavigate();
    const { updateLoader } = useAppContext();
    const [pdfUrl, setPdfUrl] = useState('');
    const [isModalOpen, setModalOpen] = useState(true);
    const [email, setEmail] = useState('');

    const getPDFReport = () => {
        updateLoader(true);
        getAIUsecaseDocumentAPI(email)
            .then((res) => setPdfUrl(res.url))
            .catch((err) => console.error("Error fetching PDF URL: ", err))
            .finally(() => {
                updateLoader(false);
                setModalOpen(false)
            });
    };

    const onFormSubmit = (e) => {
        e.preventDefault();
        getPDFReport();
    }

    const renderEmployeeEmail = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-12">
                    <div className="">Business Email <span className="text-danger"> *</span></div>
                </div>
                <div className="col-md-12">
                    <input
                        type="text"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
            </div>
        )
    }

    const validateEmail = (email) => {
        // Regular expression for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const renderModal = () => {
        return (
            <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
                <div className="d-flex flex-column gap-4">
                    <h5>Get Booklet</h5>
                    <form onSubmit={onFormSubmit} className="d-flex flex-column gap-4">
                        {renderEmployeeEmail()}
                        <button type="submit" className="btn1 font-weight-bold mx-auto w-50" disabled={!validateEmail(email)}>Generate Booklet</button>
                    </form>
                </div>
            </Modal>
        )
    }

    return (
        <>
            {renderModal()}
            <div className="d-flex justify-content-between align-items-center">
                <h3 className=" text-blue h4 mb-3 mb-0">{SECTION_NAMES.AI_USE_CASE_BOOKLET}</h3>
                <div className="d-flex align-items-center gap-4">
                    <DisabledNavLink to='/ai-roadmap'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.AI_ROADMAP}</p></DisabledNavLink>
                    <DisabledNavLink to='/timeline'><p className="m-0 p-0">{SECTION_NAMES.TIMELINE_AND_COST}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                </div>
            </div>
            <h3 className=" text-blue h4  mb-5"></h3>
            <div className="col-md-10 mx-auto">
                {pdfUrl && <PDFViewer fileUrl={pdfUrl} />}
                {!pdfUrl && <div className="text-center my-5">
                    <p>Loading...</p>
                    <button type="button" className="btn1 font-weight-bold mx-auto w-25" onClick={() => setModalOpen(true)}>Get Booklet</button>
                </div>}
            </div>
            {/* <div style={{ textAlign: "center" }}>
                <button className="slick-arrow slick-prev slick-prev-page" onClick={() => navigate('/ai-roadmap')}></button>
                <button className={`slick-arrow slick-next slick-next-page`} onClick={() => navigate('/timeline')}></button>
            </div> */}
        </>
    );
};

export default AIUsecase;
